import { ApiAbstract } from '../abstract';

export class ApiSendEmail extends ApiAbstract<any, any> {}
